import { render, staticRenderFns } from "./AssignmentAnswerList.vue?vue&type=template&id=f6dbc6a8"
import script from "@/services/assignment/answer/assignment-answer-list.js?vue&type=script&lang=js&external"
export * from "@/services/assignment/answer/assignment-answer-list.js?vue&type=script&lang=js&external"
import style0 from "@/assets/css/assignment/common-assignment.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports